var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
export const getAiPopover = () => {
  const element = document.createElement('span');
  const el2 = document.createElement('span');
  element.appendChild(el2);
  const comp = new AiPopover({});
  comp.$mount(el2);
  return {
    element,
    comp
  };
};
let AiPopover = class AiPopover extends Vue {
  get style() {
    return `background: #d8d8d8;
    border-radius: 4px;
    font-size: 10px;
    display: inline-flex;
    height: 16px;
    width: 20px;
    justify-content: center;
    padding-top: 1px;
    margin-left: 8px;`;
  }
  render() {
    const h = arguments[0];
    return h("a-tooltip", [h("span", {
      "slot": 'title'
    }, ["\u6309tab\u542F\u7528ai"]), h("span", {
      "style": this.style,
      "on": {
        "click": () => {
          this.$emit('startAi');
        }
      }
    }, ["AI"])]);
  }
};
AiPopover = __decorate([Component({
  name: 'AiPopover'
})], AiPopover);
export { AiPopover };
//# sourceMappingURL=AiPopover.js.map
